import { gql } from '@apollo/client'

// Driver work list — the dedicated driver-scoped endpoint, NOT recentOrders: a
// DeliveryDriver role has no order.list.* permission and hard-errors there. The WHERE
// is fixed server-side (order_type delivery, delivered_by 'own', active statuses);
// the args are a scheduled_for service window with the same semantics as the board's.
// No money fields and no order lines by design (owner decision: the driver screen
// shows none, and the printed merchant receipt on the bag is the packing slip).
export const GET_DRIVER_DELIVERIES = gql`
  query DriverDeliveries($from: String, $to: String) {
    driverDeliveries(scheduled_from: $from, scheduled_to: $to) {
      id
      order_number
      status
      current_status_since
      scheduled_for
      is_preorder
      customer_name
      customer_phone
      customer_phone_access_code
      delivery_street
      delivery_house_number
      delivery_postcode
      delivery_city
      delivery_instructions
      delivered_by_user {
        id
        name
      }
    }
  }
`
